module.exports = __webpack_public_path__ + "cc64a180e83edbee90e4057adcb1bdb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/planetarysystem.svg
// module id = 18
// module chunks = 0 1